module.exports = __webpack_public_path__ + "static/media/help-banner.d49cb77e.png";